import { makeStyles } from '@material-ui/core';
import tw from 'twin.macro';

export default makeStyles(() => ({
  modal: tw`flex items-start justify-center`,
  paper: () => ({
    ...(tw`p-8 gap-8 bg-white flex flex-col justify-around items-center`),
  }),
  logo: {
    '& path': tw`fill-current text-blue-600`,
  },
}));
